import { render, staticRenderFns } from "./damageModal.vue?vue&type=template&id=5c9ea4d3&scoped=true&"
import script from "./damageModal.vue?vue&type=script&lang=js&"
export * from "./damageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9ea4d3",
  null
  
)

export default component.exports